/*
 * @Author: Michael
 * @Date: 2019-03-13 11:26:41
 * @Last Modified by: mikey.zhaopeng
 * @Last Modified time: 2021-09-10 14:35:24
 */
import Vue from 'vue';
import store from '@/store';
import router from '@/router/router';

import getActivityType from '@/common/utils/getActivityType';
import getUrlParam from '@/common/utils/getUrlParam';
import { formatMoney } from '@/common/utils/format';

import { exchangeMsgToXcx } from '@/common/utils/wechatFunc';
import { pickHtmlTextContent } from '@/common/utils/dealWithString';

import fetch from '@/common/api/fetch';
import CONFIG from '@/common/config';
import { AxiosPromiseData, AxiosPromiseError, ShareObjectInterface, DetailsData } from '@/common/interface';

import { wechatShareConfig } from './wechatConfig';

const PAY_EXPIRED = 2; // 支付过期
const HAS_PAID = 1; // 报名已支付
const UN_PAID = 0; // 报名未支付

const TEXT_MESSAGE: {
  [index: string]: string;
} = {
  tyType: '该活动奖品已被领完',
  bargainType: '该活动课程已被抢完',
  lessonType: '名额已抢完！'
};
const TITLE_MESSAGE: {
  [index: string]: string;
} = {
  tyType: '很抱歉',
  bargainType: '很抱歉',
  lessonType: '手速慢'
};

const ORDER_LIST_URL: {
  [index: string]: string;
} = {
  bargainType: 'anon/bargain/getRankList',
  tyType: 'c/xm/show/ty/get/order/list'
};

const NEW_ACTIVITY_DETAIL_URL: {
  [index: string]: string;
} = {
  lessonType: 'anon/lesson/getViewerDetail',
  solitaireType: 'anon/solitaire/getViewerDetail',
  bargainType: 'anon/bargain/getViewerDetail',
  groupType: 'anon/group/getViewerDetail',
  gachaType: 'anon/gacha/getViewerDetail',
  poseType: 'anon/pose/getViewerDetail'
};

const POST_URL = `c/xm/show/ty/detail`;
const NEW_POST_URL = 'anon/businessShow/getActivityContent';

export default function getActivityDetail(xcxFlag: boolean) {
  const broadcastId: string = getUrlParam('broadcastId') as string;
  if (broadcastId) {
    if (getActivityType() !== 'gachaType') {
      Vue.$loading.show('正在加载…');
    } else {
      store.dispatch('changeGachaLoading', true);
    }
    const templateType = getActivityType();
    if (templateType === 'tyType') {
      // 集赞
      const param = {
        broadcastId,
        openId: store.state.openId
      };
      fetch
        .post(POST_URL, param)
        .then(async (res: AxiosPromiseData) => {
          Vue.$loading.hide();
          const { data } = res;

          const {
            uid,
            instId,
            title,
            cover,
            deadline,
            startTime,
            shareCover,
            browseNumber,
            joinNumber,
            htmUrl,
            instVOList = [],
            madeByOrg,
            leftPrizeNum
          } = data;

          const remoteData = {
            title,
            htmUrl,
            joinNumber,
            instId,
            scanNumber: browseNumber,
            deadline: Number(deadline),
            startTime: Number(startTime),
            instVOList: instVOList || [],
            madeByOrg: !!madeByOrg
          };
          if (xcxFlag && instId) {
            showWebsiteBtn(instId);
          }
          const content = JSON.parse(data.content);
          const parameter = JSON.parse(data.parameter);

          console.log('集赞c端-data', data);
          console.log('集赞c端-content', content);
          console.log('集赞c端-parameter', parameter);

          const { documentTitle, payType, prizeName, activityIntros, activityRule } = content;
          const { needPay, payAmount, isLimited, mustMinPay, needAuthCode, needLimitNormalStu } = parameter;
          const payload = {
            remoteData,
            content,
            parameter
          };
          if (data.extId) {
            store.dispatch('changeShowExtId', data.extId);
          } else {
            store.dispatch('changeShowExtId', '');
          }
          store.dispatch('getDetailData', payload);
          store.dispatch('changeCoverTiny', shareCover);
          store.dispatch('switchPotentialJoin', Boolean(needLimitNormalStu));
          store.dispatch('switchSMSVerify', Boolean(needAuthCode));
          store.dispatch('changeLeftQuota', leftPrizeNum);
          if (documentTitle) {
            store.dispatch('changeDocumentTitle', documentTitle);
          }
          let location = window.location.href.replace(/[?, &]code.*state/i, '');
          if (uid) {
            store.dispatch('changeUid', { uid });
            if (!getUrlParam('uid')) {
              store.dispatch('changeUrlUid', uid);
              location = location + '&uid=' + uid;
            }
          }
          // 如果活动已过期，则弹窗
          if (+new Date() > Number(deadline)) {
            Vue.$confirm({
              oneBtn: true,
              title: '来晚啦',
              text: '活动已结束！',
              okText: '确定'
            });
          }

          // 兼容-处理活动说明(集赞)
          if (!activityIntros && activityRule) {
            const payload = [{ type: 'text', value: activityRule }];
            store.dispatch('replaceActivityIntros', payload);
          }

          getActivityType() === 'tyType' && getTyActivityDetails(data);
          getUrlParam('type') === 'share' && getShareActivityDetails(data, location);
          store.dispatch('changeDetailLoaded', true);
        })
        .catch((error: AxiosPromiseError) => {
          if (error.resultCode === 1403) {
            store.dispatch('changeInValidModal', true);
          }
        });
    } else {
      const param = {
        activityId: broadcastId
      };
      fetch.Sales(NEW_POST_URL, param).then(async (res: AxiosPromiseData) => {
        setTimeout(() => {
          store.dispatch('changeGachaLoading', false);
        }, 200);
        const { result } = res;
        const {
          extId,
          instName,
          releaseStatus,
          title,
          deadline,
          startTime,
          cover,
          joinDetail,
          browseNumber,
          joinNumber,
          qrCodeUrl,
          isInvalid,
          instVOList = [],
          madeByOrg,
          channel
        } = result;

        store.dispatch('changeIsInvalid', isInvalid);
        if (releaseStatus === 2 || isInvalid) {
          store.dispatch('changeInValidModal', true);
        }
        store.dispatch('changeReleaseStatus', releaseStatus);
        const remoteData = {
          title,
          cover,
          qrCodeUrl,
          joinNumber,
          instId: extId,
          instName,
          scanNumber: browseNumber,
          deadline: Number(deadline),
          startTime: Number(startTime),
          content: {},
          instVOList: instVOList || [],
          madeByOrg: !!madeByOrg
        };
        if (xcxFlag && extId) {
          showWebsiteBtn(extId);
        }
        remoteData.content = result.content;
        const content = JSON.parse(result.content);
        const parameter = JSON.parse(result.parameter);

        console.log('c端data(除集赞)', result);
        console.log('c端cotent(除集赞)', content);
        console.log('c端parameter(除集赞)', parameter);
        console.log('uid', getUrlParam('uid'));

        const { documentTitle, activityIntros, activityRule, payType, prizeName, prizeDesc, prizePic } = content;
        const { needPay, payAmount, isLimited, mustMinPay, needAuthCode, needLimitNormalStu } = parameter;
        // 扭蛋机
        if (getActivityType() === 'gachaType') {
          content.gachaTypeParameter.prize.proList = result.additionalInfo.prizes;
          const { showBarrage, showData } = content.gachaTypeParameter;
          store.dispatch('changeShowBarrage', showBarrage);
          store.dispatch('changeShowData', showData == undefined ? true : showData);
          store.dispatch('changeJoinNumber', result.joinNumber || 0);
          store.dispatch('changeScanNumber', result.browseNumber || 0);
          content.selectedBGM = { id: 0, category: '', name: '默认背景音乐', url: 'https://image.xiaomaiketang.com/xm/YkiWbG4ydT.mp3', loop: true };
        }
        const payload = {
          remoteData,
          content,
          parameter
        };
        if (extId) {
          console.log('我执行了+++++++++++++', extId);
          store.dispatch('changeShowExtId', extId);
        } else {
          store.dispatch('changeShowExtId', '');
        }
        store.dispatch('getDetailData', payload);
        store.dispatch('changeCoverTiny', cover);
        store.dispatch('switchPotentialJoin', Boolean(needLimitNormalStu));
        store.dispatch('switchSMSVerify', Boolean(needAuthCode));
        if (documentTitle) {
          store.dispatch('changeDocumentTitle', documentTitle);
        }
        let location = window.location.href.replace(/[?, &]code.*state/i, '');
        // 分销类型的openId传递的是分销小程序的openID
        if (getActivityType() === 'distributeType') {
          if (getUrlParam('fxXcxopenId')) {
            const distributorId = getUrlParam('distributorId');
            fetch
              .Sales('anon/show/distribute/currentViewerInfo', {
                ...param,
                parentUid: distributorId || '-1',
                openId: getUrlParam('fxXcxopenId')
              })
              .then((res: any) => {
                if (res.result.hasSignIn) {
                  let { totalDealAmount = 0, tradeCreateTime } = res.result;
                  totalDealAmount = (totalDealAmount / 100).toFixed(2);
                  const { userId, payState, tradeId, cancel } = res.result.signIn;
                  if (payState === 4 || (payState !== 4 && cancel)) {
                    store.dispatch('changeHasSignIn', true);
                  }
                  store.dispatch('changeUid', { uid: userId });
                  store.dispatch('changeHasPay', payState);
                  store.dispatch('changeCancel', cancel);
                  store.dispatch('changeMyReward', totalDealAmount);
                  store.dispatch('changeDistributeOrderCreateTime', tradeCreateTime);
                  store.dispatch('changeDistributeTradeId', tradeId);
                }
              });
          }
          store.dispatch('changeChannel', channel || '');
        } else if (store.state.openId) {
          fetch
            .newpost(NEW_ACTIVITY_DETAIL_URL[getActivityType()], {
              ...param,
              openId: store.state.openId
            })
            .then(async (res: AxiosPromiseData) => {
              const { result: tempRes } = res;
              if (tempRes) {
                const { payState, userId, avatar, name, phone, instId, additionalInfo, cancel = false } = tempRes;
                const userAwardInfo = tempRes;
                const uid = getUrlParam('uid');
                const activityType = getActivityType();
                store.dispatch('changeJoinInfo', { instId, name, phone, signupItemConfig: additionalInfo });
                store.dispatch('changeUserAwardInfo', userAwardInfo);
                store.dispatch('changePosterName', name);
                store.dispatch('changePosterAvatar', avatar);
                store.dispatch('changeCancel', cancel); // 是否取消报名

                // 如果已经报名了, 就将uid的值置为userId
                if (userId) {
                  store.dispatch('changeUid', { uid: userId });
                }
                // 团购活动要在支付成功或不需要支付的情况下才可以将urlUid的值置为uid
                if (!uid && (payState === 4 || payState === -1 || (payState === 3 && cancel)) && activityType === 'groupType') {
                  const param = {
                    userId,
                    activityId: getUrlParam('broadcastId')
                  };
                  const resGroup = await fetch.newpost('anon/group/getCurrentGroup', param);
                  console.log('xxxx', userId, resGroup.result.groupDetailVOS);
                  location = location + '&uid=' + resGroup.result.groupDetailVOS[0].userId;
                  store.dispatch('changeUrlUid', resGroup.result.groupDetailVOS[0].userId);
                }
                // 查看机构分享的页面，那么当前的urlUid就为当前用户的userId
                if (!uid && activityType !== 'groupType') {
                  location = location + '&uid=' + userId;
                  store.dispatch('changeUrlUid', userId);
                  getActivityType() === 'bargainType' && getBargainLeader(userId);
                }

                // 团购活动,报名未支付的情况下,将uid重新置为空
                if (userId && (payState === 2 || payState === 3) && activityType === 'groupType') {
                  store.dispatch('changeUid', { uid: '' });
                }

                // 如果开启支付了，就更新支付状态
                if (needPay) {
                  store.dispatch('changeHasPay', payState);
                }

                getUrlParam('type') === 'share' && getShareActivityDetails(result, location);
              }
            });
        }
        // 请求分享者的报名信息
        if (getUrlParam('uid') && getActivityType() === 'bargainType') {
          getBargainLeader(getUrlParam('uid'));
        }
        // 请求扭蛋机分享者的报名信息
        if (getUrlParam('uid') && getActivityType() === 'gachaType') {
          getGachaLeader(getUrlParam('uid'));
        }
        // 如果活动已过期，则弹窗
        if (+new Date() > Number(deadline) && !isInvalid) {
          Vue.$confirm({
            oneBtn: true,
            title: '来晚啦',
            text: '活动已结束！',
            okText: '确定'
          });
        }

        // 兼容-处理活动说明(除集赞)
        if (!activityIntros && activityRule) {
          const payload = [{ type: 'text', value: activityRule }];
          store.dispatch('replaceActivityIntros', payload);
        }

        getActivityType() === 'solitaireType' && getSolitaireActivityDetails(result);
        getActivityType() === 'distributeType' && getDistributeActivityDetails(result);
        getActivityType() === 'lessonType' && getLessonActivityDetails(result);
        getActivityType() === 'bargainType' && getBargainActivityDetaisl(result);
        getActivityType() === 'groupType' && getGroupActivityDetails(result);
        getUrlParam('type') === 'share' && getShareActivityDetails(result, location);
        setTimeout(() => {
          store.dispatch('changeDetailLoaded', true);
        }, 300);
      });
    }
  }
}

// 获取分享页面的详细信息
function getShareActivityDetails(data: DetailsData, location: string) {
  const { title, shareCover, cover, openGroupNum, fullGroupNum, completeGroupNum } = data;
  const { activityRule, courseDesc, prizeDesc } = JSON.parse(data.content);
  const urlUid: string = store.state.urlUid;
  if (!window.WeixinJSBridge || !window.WeixinJSBridge.invoke) {
    document.addEventListener(
      'WeixinJSBridgeReady',
      () => {
        exchangeMsgToXcx(urlUid);
      },
      false
    );
  } else {
    exchangeMsgToXcx(urlUid);
  }
  // exchangeMsgToXcx(urlUid);
  const env: string = (process.env.VUE_APP_DEPLOY_ENV as string) || 'dev';
  const linkUrl: string =
    (CONFIG.shareUrl as any)[env] +
    (CONFIG.appId as any)[env] +
    '&redirect_uri=' +
    encodeURIComponent(location) +
    '&response_type=code&scope=snsapi_base&state=state#wechat_redirect';
  let shareObject: ShareObjectInterface = {
    title: title.replace(/<br\/>/g, '\n'),
    desc: pickHtmlTextContent(activityRule),
    link: linkUrl,
    imgUrl: shareCover || cover
  };

  if (getActivityType() === 'bargainType') {
    shareObject = {
      title: title.replace(/<br\/>/g, '\n'),
      desc: pickHtmlTextContent(prizeDesc),
      link: linkUrl,
      imgUrl: cover
    };
  }
  if (getActivityType() === 'groupType') {
    const groupData = {
      groupCreateNumber: openGroupNum,
      groupCompleteNumber: completeGroupNum,
      groupFullNumber: fullGroupNum
    };
    store.dispatch('changeGroupNumber', groupData);
    shareObject = {
      title: title.replace(/<br\/>/g, '\n'),
      desc: pickHtmlTextContent(courseDesc),
      link: linkUrl,
      imgUrl: shareCover
    };
  }
  store.dispatch('changePosterUrl', linkUrl);
  wechatShareConfig(shareObject);
  store.dispatch('changeShowJoinFooter', true);
}
// 获取分销活动的详细信息
function getDistributeActivityDetails(data: DetailsData) {
  //获取剩余课程信息
  const broadcastId: string = getUrlParam('broadcastId') as string;
  const param = {
    activityId: broadcastId
  };
  const content = JSON.parse(data.content);
  const { courseName, limitBuyerNum, courseOriginPrice, courseRushPrice } = content;
  store.dispatch('changeShowBarrage', content.showBarrage);
  store.dispatch('changeShowData', content.showData == undefined ? true : content.showData);
  store.dispatch('changeJoinNumber', data.joinNumber || 0);
  store.dispatch('changeScanNumber', data.browseNumber || 0);
  store.dispatch('changeInstPhone', content.instPhone);
  store.dispatch('changeDistributeParameter', content.distributeTypeParameter);
  store.dispatch('changeSectionInfo', {
    value: courseName,
    type: 'courseName'
  });
  store.dispatch('changeSectionInfo', {
    value: limitBuyerNum,
    type: 'limitBuyerNum'
  });
  store.dispatch('changeSectionInfo', {
    value: Number((courseOriginPrice / 100).toFixed(2)),
    type: 'courseOriginPrice'
  });
  store.dispatch('changeSectionInfo', {
    value: Number((courseRushPrice / 100).toFixed(2)),
    type: 'courseRushPrice'
  });
  store.dispatch('changeSectionInfo', { type: 'detailLoading', value: true });
  // 剩余名额
  store.dispatch('changeLeftQuota', data.leftQuota);
  // fetch.Sales("anon/show/distribute/fetchCourseInfo", param)
  // .then((res: any) => {
  //   const {leftQuota} =  res.result;
  //   store.dispatch('changeLeftQuota', leftQuota);
  // });
  //获取已购买人的信息
  fetch.Sales('anon/show/distribute/fetchPurchaseList', param).then((res: any) => {
    store.dispatch('changeDistributePurchaseList', res.result);
  });
}
// 获取群接龙活动的详细信息
function getSolitaireActivityDetails(data: DetailsData) {
  // 还有人数上限和已报名
  const { deadline, leftQuota, payNumber } = data;
  const { courseName, courseDesc, coursePic, courseIntros, payType, solitaireList } = JSON.parse(data.content);

  const { virtualGroup, needPay, payAmount } = JSON.parse(data.parameter);

  store.dispatch('changeSectionInfo', { type: 'courseName', value: courseName });
  store.dispatch('changeSectionInfo', { type: 'courseDesc', value: courseDesc });
  store.dispatch('changeSectionInfo', { type: 'coursePic', value: coursePic });
  // 兼容-课程信息-群接龙
  if (!courseIntros) {
    const _courseIntros = [];
    if (courseDesc) {
      _courseIntros.push({
        type: 'text',
        value: courseDesc
      });
    }
    if (coursePic) {
      let _list = coursePic.split('@').filter((item: string) => {
        return item;
      });
      for (let i = 0; i < _list.length; i++) {
        _courseIntros.push({
          type: 'img',
          value: _list[i]
        });
      }
    }
    store.dispatch('changeSectionInfo', { type: 'courseIntros', value: _courseIntros || [] });
  } else {
    store.dispatch('changeSectionInfo', { type: 'courseIntros', value: courseIntros || [] });
  }
  // store.dispatch('changeSectionInfo', { type: 'courseIntros', value: courseIntros });
  store.dispatch('changeLeftQuota', leftQuota);
  store.dispatch('changePayNumber', { number: formatMoney(payAmount, 100, true) });
  store.dispatch('changePayType', { payType: payType });
  store.dispatch('switchCanPay', { status: needPay });
  store.dispatch('changeVirtualGroup', virtualGroup);
  store.dispatch('changeHasPaidNumber', payNumber);
}

// 获取团购活动的详细信息
function getGroupActivityDetails(data: DetailsData) {
  const { deadline, completeGroupNum, fullGroupNum, content, parameter } = data;
  const { courseName, courseDesc, coursePic, courseIntros, payType, ladderGroupList, courseType, courseGroupList } = JSON.parse(content);
  const { minPrice, maxPrice, groupNum, groupSize, payAmount, needPay, virtualGroup, unGroupSwitch, autoCancel } = JSON.parse(parameter);
  store.dispatch('changeSectionInfo', { type: 'courseName', value: courseName });
  store.dispatch('changeSectionInfo', { type: 'courseDesc', value: courseDesc });
  store.dispatch('changeSectionInfo', { type: 'coursePic', value: coursePic });
  store.dispatch('changeSectionInfo', { type: 'currentPrice', value: formatMoney(minPrice, 100, true) });
  store.dispatch('changeSectionInfo', { type: 'originPrice', value: formatMoney(maxPrice, 100, true) });
  store.dispatch('changeSectionInfo', { type: 'groupNumber', value: groupNum });
  store.dispatch('changeSectionInfo', { type: 'personNumber', value: groupSize });
  store.dispatch('changePayNumber', { number: formatMoney(payAmount, 100, true) });
  store.dispatch('changePayType', { payType: payType });
  store.dispatch('switchCanPay', { status: needPay });
  store.dispatch('changeVirtualGroup', virtualGroup);

  // 兼容-未成团列表开关-团购
  if (unGroupSwitch === false) {
    store.dispatch('changeUnGroupSwitch', unGroupSwitch);
  } else {
    store.dispatch('changeUnGroupSwitch', true);
  }
  // 兼容-拼团失败自动取消报名开关-团购
  if (autoCancel === true) {
    store.dispatch('changeAutoCancel', autoCancel);
  } else {
    store.dispatch('changeAutoCancel', false);
  }
  // 兼容-多课程
  if (!courseType) {
    store.dispatch('changeSectionInfo', { type: 'courseType', value: 'ONE' });
  } else {
    store.dispatch('changeSectionInfo', { type: 'courseType', value: courseType });
  }

  // 兼容-课程列表
  if (!courseGroupList) {
    // 兼容-课程信息-团购
    let _courseIntros = courseIntros;
    if (!courseIntros) {
      const intros = [];
      if (courseDesc) {
        intros.push({
          type: 'text',
          value: courseDesc
        });
      }
      if (coursePic) {
        let _list = coursePic.split('@').filter((item: string) => {
          return item;
        });
        for (let i = 0; i < _list.length; i++) {
          intros.push({
            type: 'img',
            value: _list[i]
          });
        }
      }
      _courseIntros = intros;
    }
    // 兼容-拼团方案
    let _ladderGroupList = ladderGroupList;
    if (!ladderGroupList) {
      _ladderGroupList = [{ groupSize: groupSize, groupPrice: minPrice / 100 }];
      store.dispatch('changeLadderGroup', _ladderGroupList);
    } else {
      store.dispatch('changeLadderGroup', ladderGroupList);
    }
    let _courseGroupList = [
      {
        seqNo: 1,
        courseCover: '',
        courseName,
        courseIntros: _courseIntros,
        originPrice: maxPrice / 100,
        ladderGroupList: _ladderGroupList
      }
    ];
    console.log('兼容_courseGroupList', _courseGroupList);
    store.dispatch('changeSectionInfo', { type: 'courseGroupList', value: _courseGroupList });
  } else {
    store.dispatch('changeSectionInfo', { type: 'courseGroupList', value: courseGroupList });
  }

  groupFull(data);
  getSelfGroup(data);
}

// 获取集赞活动的详细信息
function getTyActivityDetails(data: DetailsData) {
  const {
    state: { urlUid }
  } = store;
  const { leftPrizeNum, deadline } = data;
  const { prizeIntros, prizeName, prizeDesc, prizePic, showBarrage, showData, viewBackground } = JSON.parse(data.content);
  const { prizeNum, unitNum, goodValue, normalValue, badValue, intervalTime } = JSON.parse(data.parameter);

  store.dispatch('changeShowBarrage', showBarrage);
  store.dispatch('changeShowData', showData == undefined ? true : showData);
  store.dispatch('changeJoinNumber', data.joinNumber || 0);
  store.dispatch('changeScanNumber', data.browseNumber || 0);
  store.dispatch('changeViewBackground', viewBackground);
  store.dispatch('changeSectionInfo', { type: 'prizeName', value: prizeName });
  store.dispatch('changeSectionInfo', { type: 'prizeDesc', value: prizeDesc });
  store.dispatch('changeSectionInfo', { type: 'prizePic', value: prizePic });

  // 兼容-奖品介绍富文本-集赞
  if (!prizeIntros) {
    const _prizeIntros = [];
    if (prizeDesc) {
      _prizeIntros.push({
        type: 'text',
        value: prizeDesc
      });
    }
    if (prizePic) {
      let _list = prizePic.split('@').filter((item: string) => {
        return item;
      });
      for (let i = 0; i < _list.length; i++) {
        _prizeIntros.push({
          type: 'img',
          value: _list[i]
        });
      }
    }
    store.dispatch('changeSectionInfo', { type: 'prizeIntros', value: _prizeIntros || [] });
  } else {
    store.dispatch('changeSectionInfo', { type: 'prizeIntros', value: prizeIntros || [] });
  }

  // store.dispatch('changeSectionInfo', { type: 'prizeIntros', value: prizeIntros });

  window.prizeNum = prizeNum;
  const tempParameter = {
    prizeNum,
    unitNum,
    goodValue,
    normalValue,
    badValue,
    prizeLeftCount: leftPrizeNum,
    intervalTime: formatMoney(intervalTime, 60, true)
  };
  store.dispatch('changeTyTypeParameter', tempParameter);
  //奖品被领完 未报名
  if (+new Date() < Number(deadline) && !urlUid && Number(leftPrizeNum) <= 0) {
    prizeWasReceived();
  }
  // 报名但未到底价
  if (+new Date() < Number(deadline) && urlUid && Number(leftPrizeNum) <= 0) {
    notReachMinPrice();
  }
}

function getBargainLeader(userId: string | undefined) {
  fetch
    .newpost('anon/bargain/getBargainLeader', {
      userId,
      activityId: getUrlParam('broadcastId')
    })
    .then((res: AxiosPromiseData) => {
      const { result } = res;
      const { xmShowSignInVO } = result;
      const { rank, currentPrice, totalBargainTime } = result;

      const { avatar, name, phone, additionalInfo, instId } = xmShowSignInVO;
      store.dispatch('changeBargainParameter', {
        totalBargainTime, // 砍价次数
        currentRank: rank + 1, // 排名
        currentPrice: formatMoney(currentPrice, 100, true) // 当前价格
      });
      store.dispatch('changePayInstId', instId);
      store.dispatch('changeJoinInfo', { name, phone, signupItemConfig: additionalInfo });
      store.dispatch('changePosterName', name);
      store.dispatch('changePosterAvatar', avatar);
    })
    .catch((e: AxiosPromiseError) => {
      throw new Error(e.message);
    });
}
function getGachaLeader(userId: string | undefined) {
  fetch
    .newpost('anon/gacha/getLeaderDetail', {
      userId,
      activityId: getUrlParam('broadcastId')
    })
    .then((res: AxiosPromiseData) => {
      const { result } = res;
      const { xmShowSignInVO } = result;
      const { avatar, name } = result;
      const userAwardInfo = result;
      store.dispatch('changeUserAwardInfo', userAwardInfo);
      store.dispatch('changePosterName', name);
      store.dispatch('changePosterAvatar', avatar);
    })
    .catch((e: AxiosPromiseError) => {
      throw new Error(e.message);
    });
}
// 获取砍价活动的详细信息
function getBargainActivityDetaisl(data: DetailsData) {
  const {
    state: { urlUid }
  } = store;
  const { leftPrizeNum, deadline, leftQuota, parameter, content } = data;
  const { needPay, prizeNum, minPrice, maxPrice, mustMinPay, minCutPrice, maxCutPrice, intervalTime } = JSON.parse(parameter);
  const { prizeIntros, prizePic, prizeDesc, prizeName } = JSON.parse(content);
  store.dispatch('changeLeftQuota', leftQuota);
  store.dispatch('switchMustMinPay', mustMinPay);
  store.dispatch('switchCanPay', { status: needPay });
  store.dispatch('changeBargainParameter', {
    prizeNum,
    minPrice: formatMoney(minPrice, 100, true),
    maxPrice: formatMoney(maxPrice, 100, true),
    minCutPrice: formatMoney(minCutPrice, 100, true),
    maxCutPrice: formatMoney(maxCutPrice, 100, true),
    intervalTime: formatMoney(intervalTime, 60, true)
  });

  store.dispatch('changeSectionInfo', { type: 'prizeName', value: prizeName });
  store.dispatch('changeSectionInfo', { type: 'prizeDesc', value: prizeDesc });
  store.dispatch('changeSectionInfo', { type: 'prizePic', value: prizePic });
  // 兼容-课程介绍富文本-砍价
  if (!prizeIntros) {
    const _prizeIntros = [];
    if (prizeDesc) {
      _prizeIntros.push({
        type: 'text',
        value: prizeDesc
      });
    }
    if (prizePic) {
      let _list = prizePic.split('@').filter((item: string) => {
        return item;
      });
      for (let i = 0; i < _list.length; i++) {
        _prizeIntros.push({
          type: 'img',
          value: _list[i]
        });
      }
    }
    store.dispatch('changeSectionInfo', { type: 'prizeIntros', value: _prizeIntros || [] });
  } else {
    store.dispatch('changeSectionInfo', { type: 'prizeIntros', value: prizeIntros || [] });
  }
  // store.dispatch('changeSectionInfo', { type: 'prizeIntros', value: prizeIntros });
  const isFinished = +new Date() < Number(deadline);
  if (isFinished && urlUid && leftQuota <= 0) notReachMinPrice();
  if (isFinished && !urlUid && leftQuota <= 0) prizeWasReceived();
}

// 获取微传单活动的详细信息
function getLessonActivityDetails(data: DetailsData) {
  const { leftQuota, deadline, joinDetail } = data;
  const { needPay, payAmount, isLimited } = JSON.parse(data.parameter);
  const { payType } = JSON.parse(data.content);
  store.dispatch('changePayType', { payType });
  store.dispatch('changeLeftQuota', leftQuota);
  store.dispatch('switchCanPay', { status: needPay });
  store.dispatch('changePayNumber', { number: formatMoney(payAmount, 100, true) });

  // 如果奖品被领完，则弹窗
  if ((joinDetail && joinDetail.isCallback === PAY_EXPIRED) || !joinDetail) {
    if (+new Date() < Number(deadline) && isLimited && !leftQuota) {
      prizeWasReceived();
    }
  }
}

// 未达到底价
function notReachMinPrice() {
  const broadcastId = getUrlParam('broadcastId');
  const templateType = getActivityType();
  if (templateType === 'bargainType') {
    fetch.newpost(ORDER_LIST_URL[getActivityType()], { activityId: broadcastId }).then((res: AxiosPromiseData) => {
      res.data.forEach((item: any) => {
        if (item.sourceUserId === store.state.urlUid) {
          if (Number(item.totalCount) < Number(item.needCount)) {
            Vue.$confirm({
              oneBtn: true,
              title: '很抱歉',
              text: TEXT_MESSAGE[getActivityType()],
              okText: '确定'
            });
          }
        }
      });
    });
  } else {
    Vue.$confirm({
      oneBtn: true,
      title: '很抱歉',
      text: TEXT_MESSAGE[getActivityType()],
      okText: '确定'
    });
  }
}

// 奖品被领完后弹出提示信息
function prizeWasReceived() {
  Vue.$confirm({
    oneBtn: true,
    title: TITLE_MESSAGE[getActivityType()],
    text: TEXT_MESSAGE[getActivityType()],
    okText: '确定'
  });
}

// 满团（阶梯拼团）或则成团（非阶梯）后弹出提示信息
function groupFull(data: DetailsData) {
  const { deadline, completeGroupNum, fullGroupNum } = data;
  const { ladderGroupList } = JSON.parse(data.content);
  const { needPay, groupNum } = JSON.parse(data.parameter);
  const {
    state: { canPay, urlUid }
  } = store;

  if (+new Date() < Number(deadline) && !urlUid && Number(completeGroupNum) >= Number(groupNum) && !needPay && ladderGroupList.length === 1) {
    Vue.$confirm({
      oneBtn: true,
      title: '很抱歉',
      text: `该活动已达到${canPay ? '支付人数' : '成团数'}上限,<br />无法继续开团/参团`,
      okText: '确定'
    });
  }
  if (+new Date() < Number(deadline) && !needPay && !urlUid && Number(fullGroupNum) >= Number(groupNum)) {
    Vue.$confirm({
      oneBtn: true,
      title: '很抱歉',
      text: `该活动已达到${canPay ? '支付人数' : '满团数'}上限,<br />无法继续开团/参团`,
      okText: '确定'
    });
  }
}

// 获取当前团的信息
function getSelfGroup(data: DetailsData) {
  const { deadline, completeGroupNum } = data;
  const { needPay, groupNum } = JSON.parse(data.parameter);
  const {
    state: { canPay, uid }
  } = store;
  if (+new Date() < Number(deadline) && uid && Number(completeGroupNum) >= Number(groupNum) && !needPay) {
    const param = {
      userId: uid,
      activityId: getUrlParam('broadcastId')
    };
    fetch.post('anon/group/getCurrentGroup', param).then((res: AxiosPromiseData) => {
      const { result } = res;
      const { groupDetailVOS, groupSize, applyNum, maxGroupSize } = result;
      const leader = groupDetailVOS[0];

      if (groupDetailVOS.length) return;
      if (uid === leader.userId) {
        store.dispatch('changeJoinGroupFlag', true);
      }
      if (groupSize > applyNum) {
        Vue.$confirm({
          oneBtn: true,
          title: '很抱歉',
          text: `该活动已达到${canPay ? '支付人数' : '成团数'}上限,<br />无法继续开团/参团`,
          okText: '确定'
        });
      }
    });
  }
}
function showWebsiteBtn(theInstId: string) {
  const param = {
    instId: theInstId,
    noToken: true
  };
  fetch.Sales('anon/commonMicroWebsite/getMarketingStatus', param).then((res: any) => {
    if (res.result) {
      store.dispatch('showWesiteBtn', true);
    } else {
      store.dispatch('showWesiteBtn', false);
    }
  });
}
